import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'semantic-ui-react';

import { DEALER_PICKER_LABEL } from '../../constants/onboardingQueue';
import { dealerLabel } from '../../utilities/onboardingQueue';

const DealerPicker = ({
  dealers, value, disabled, onChange, testId,
}) => {
  const options = dealers.map(dealer => ({
    key: dealer.flatRateOfferId,
    value: dealer.flatRateOfferId,
    text: dealerLabel(dealer),
  }));

  return (
    <Form.Select
      id={testId}
      label={DEALER_PICKER_LABEL}
      options={options}
      value={value}
      disabled={disabled}
      data-testid={testId}
      onChange={(event, { value: next }) => {
        const dealer = dealers.find(item => item.flatRateOfferId === next);
        if (dealer) onChange(dealer);
      }}
    />
  );
};

DealerPicker.propTypes = {
  dealers: PropTypes.arrayOf(PropTypes.shape({
    flatRateOfferId: PropTypes.string,
    dealerName: PropTypes.string,
    customerId: PropTypes.string,
  })).isRequired,
  value: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  testId: PropTypes.string.isRequired,
};

DealerPicker.defaultProps = {
  disabled: false,
};

export default DealerPicker;
